/**
 * Known scratchpad dot-paths for the Form Node authoring UI.
 *
 * Source of truth is the Python ScratchpadContext at
 * apps/livekit/shared/src/scratchpad/types.py — keep this list in step with
 * that dataclass tree. This is the AUTHORING subset: paths exposed in the
 * Memory picker on Form items. The runtime scratchpad carries more.
 *
 * Each path is scoped by source so an author binding a question to
 * "the caller's name" never silently reads a CRM value they did not mean.
 * The source stays explicit in the label itself — no magic "best of" aliases.
 */
export const KNOWN_SCRATCHPAD_PATHS = [
    // ----- Contact -----
    {
        path: 'contact.name.crm',
        label: 'Caller name (CRM match)',
        description: 'Caller name from the CRM record linked to the phone number.',
        type: 'string',
        writable: false,
    },
    {
        path: 'contact.name.mentioned',
        label: 'Caller name (verbally captured)',
        description: 'Caller name the caller said during the call.',
        type: 'string',
        writable: true,
    },
    {
        path: 'contact.email.crm',
        label: 'Caller email (CRM match)',
        description: 'Caller email from the CRM record.',
        type: 'string',
        writable: false,
    },
    {
        path: 'contact.email.mentioned',
        label: 'Caller email (verbally captured)',
        description: 'Caller email the caller said during the call.',
        type: 'string',
        writable: true,
    },
    {
        path: 'contact.phone',
        label: 'Caller phone (this phone number)',
        description: 'Phone number the call was placed to or from.',
        type: 'string',
        writable: false,
    },
    // ----- Properties: verbally captured -----
    {
        path: 'properties.mentioned.address',
        label: 'Property address (verbally captured)',
        description: 'Property street address the caller said.',
        type: 'string',
        writable: true,
    },
    {
        path: 'properties.mentioned.name',
        label: 'Property name (verbally captured)',
        description: 'Property name the caller said (e.g. "The Grove").',
        type: 'string',
        writable: true,
    },
    {
        path: 'properties.mentioned.unit',
        label: 'Property unit (verbally captured)',
        description: 'Unit or apartment number the caller said.',
        type: 'string',
        writable: true,
    },
    // ----- Properties: CRM match -----
    {
        path: 'properties.resolved.address',
        label: 'Property address (CRM match)',
        description: 'Property address matched to the catalog during the call.',
        type: 'string',
        writable: false,
    },
    {
        path: 'properties.resolved.name',
        label: 'Property name (CRM match)',
        description: 'Property name matched to the catalog during the call.',
        type: 'string',
        writable: false,
    },
];
/**
 * Lookup helper for the admin UI and the inference service.
 */
export function findScratchpadPath(path) {
    return KNOWN_SCRATCHPAD_PATHS.find(p => p.path === path);
}
/**
 * Writable subset — safe for Form Node answers to bind onto.
 */
export const WRITABLE_SCRATCHPAD_PATHS = KNOWN_SCRATCHPAD_PATHS.filter(p => p.writable);
//# sourceMappingURL=paths.js.map